let Api = {
	// 品质评价
	"EVALUATION_LIST": "/quality/w/evaluation/findPageList", //评价项目管理列表查询
	"EVALUATION_INFO": "/quality/w/evaluation/findInfo", //查看详情
	"EVALUATION_SAVE": "/quality/w/evaluation/saveOrUpdate", //分类列表（品质评价）
	"EVALUATION_DEL": "/quality/w/evaluation/delEvaluationProject", //删除记录

	"MEMBPAGELIST": "/system/w/platMemb/findMembPageList", //申请企业
	
	"EVALUATION_FINDNFTBLACKLIST": "/quality/w/evaluation/findNftBlackList", //查询申请标签上链列表
	"SELECTCODINGSTATISTICS": "/quality/w/CertificateInfo/selCodingStatis", //查询编码统计信息
	"SELECTPRODCODINGSTATISTICS": "/quality/w/CertificateInfo/selProdCodingStatis", //赋码统计 - 产品赋码评价概览
}
module.exports = Api